<template>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-11 col-md-12">
                <button type="button" class="col-12 col-md-auto btn btn-default"
                        @click="add">{{ $lang('Nowy element') }}
                </button>
            </div>
        </div>
        <div class="row mt-3" v-if="tradeModules.length > 0">
            <table class="table simple-table table-striped table-sm">
                <thead>
                <tr>
                    <th scope="col">{{ $lang('Moduł') }}</th>
                    <th scope="col">{{ $lang('Typ') }}</th>
                    <th scope="col">{{ $lang('Domyślna wartość') }}</th>
                    <th scope="col">{{ $lang('Akcje') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(tradeModule, id) in tradeModules">
                    <td>{{tradeModule.name}}</td>
                    <td>{{tradeModule.type.showable_name}}</td>
                    <td>
                        <template v-if="tradeModule.type.kind === 'boolean'">
                            <span>{{tradeModule.default_value ? 'TAK' : 'NIE'}}</span>
                        </template>
                        <template v-if="tradeModule.type.kind === 'numeric'">
                            <span>{{tradeModule.default_value}}</span>
                        </template>
                    </td>
                    <td :data-title="$lang('Akcje')">
                        <a class="mr-3" @click.prevent="edit(tradeModule)" href="#">{{ $lang('Edytuj') }}</a>
                        <a class="mr-3" @click.prevent="remove(tradeModule.id)" href="#">{{ $lang('Usuń') }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="!load">
            <p>{{$lang('Brak danych')}}</p>
        </div>

        <div class="modal fade" id="modal_dict_licence" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{
                                modalMode === 'new' ? $lang('Nowy moduł') : $lang('Edycja modułu')
                            }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group mt-1">
                            <input class="form-control" id="new_licence" placeholder="Nazwa" v-model="moduleEditable.name">
                            <small class="text-red" v-if="error === true">
                                {{ errorMessage }}</small>
                        </div>

                        <div class="form-group mt-1">
                            <div class="row">
                                <label class="col-12">{{ $lang('Typ i wartość domyślna') }}</label>
                                <div class="col-8">
                                    <select class="form-control" id="new_licence_type" v-model="moduleEditable.type_id">
                                        <option value="">{{ $lang('Wybierz typ') }}</option>
                                        <option v-for="type in trade_module_types" :value="type.id">{{
                                                type.showable_name
                                            }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-4">
                                    <span v-if="selectedType === null"></span>
                                    <select v-else-if="selectedType.kind==='boolean'" class="form-control"
                                            v-model="moduleEditable.default_value">
                                        <option value="0">{{ $lang('Nie') }}</option>
                                        <option value="1">{{ $lang('Tak') }}</option>
                                    </select>
                                    <input v-else-if="selectedType.kind==='numeric'"
                                           class="form-control" type="number" min="0" v-model="moduleEditable.default_value"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button id="licence-new" v-if="modalMode === 'new'" @click.prevent="create()" type="button"
                                class="btn btn-primary" :disabled="!newLicenceValid">
                            {{ $lang('Utwórz') }}
                        </button>
                        <button id="licence-edit" v-else @click.prevent="update()" type="button" class="btn btn-primary"
                                :disabled="!newLicenceValid">
                            {{ $lang('Zapisz') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "dictionary-licence",
    mixins: [ShowNotification],
    props: ['update_route', 'get_route', 'store_route', 'delete_route', 'trade_module_types'],
    data() {
        return {
            load: true,
            tradeModules: [],
            selectedType: null,
            value: '',
            licences: [],
            error: false,
            errorMessage: '',
            tradeModuleType: '',
            moduleEditable: {
                id: null,
                name: '',
                type_id: null,
                default_value: null,
            },
            modalMode: 'add'
        }
    },
    methods: {
        get() {
            let self = this;
            axios.get(this.get_route, {})
                 .then(function (response) {
                     self.tradeModules = response.data;
                     self.load = false;
                 })
                 .catch((error) => {
                 });
        },
        create() {
            let self = this;
            axios.post(this.store_route, this.moduleEditable)
                 .then(function (response) {
                     self.tradeModules = response.data;
                     self.add();
                     // $('#modal_dict_licence').modal('hide');
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        update() {
            let self = this;
            axios.patch(this.update_route, this.moduleEditable)
                 .then(function (response) {
                     self.tradeModules = response.data;
                     $('#modal_dict_licence').modal('hide');
                 })
                 .catch((error) => {
                     console.log(error);
                     if (error.response.status === 422) {
                         self.error = true;
                         self.errorMessage = error.response.data;
                     }
                 });
        },
        remove(id) {
            let self = this;
            axios.post(this.delete_route, {id: id})
                 .then(function (response) {
                     self.tradeModules = response.data;
                 })
                 .catch((error) => {
                     if (error.response.status === 422) {
                         this.showNotification('error', error.response.data.errors)
                     } else if (error.response.status === 400) {
                         self.showNotification('error', 'Moduł jest aktualnie wykorzystywany przez biblioteki. Aby go usunąć zlikwiduj powiązania. Powiązania' + ": " + error.response.data.libraries);
                     } else {
                         console.log(error);
                     }
                 });
        },
        add() {
            this.openModal('new', null, '', null, null);
        },
        edit(licence) {
            this.openModal('edit', licence.id, licence.name, licence.type_id, licence.default_value);
        },
        openModal(mode, id, name, type_id, default_value) {
            this.modalMode = mode;
            this.error = false;
            this.errorMessage = '';

            this.moduleEditable.id = id;
            this.moduleEditable.name = name;
            this.moduleEditable.type_id = type_id;
            this.moduleEditable.default_value = default_value;
            $('#modal_dict_licence').modal('show');
        },
        getType(editable) {
            if (typeof this.trade_module_types !== 'undefined') {
                for (const type of this.trade_module_types) {
                    if (type.id === editable.type_id) {
                        return type;
                    }
                }
            }
            return 0;
        }

    },
    watch: {
        moduleEditable: {
            handler(newValue, oldValue) {
                this.selectedType = this.getType(newValue);
            },
            deep: true
        }
    },
    computed: {
        newLicenceValid() {
            return this.moduleEditable.name !== '';
        }
    }
    ,
    created() {
        // console.log(this.trade_module_types);
        this.get();
    }
    ,
    mounted() {

    }
}
</script>
